"use client";

import { useReducedMotion } from "framer-motion";
import { useLocale, useTranslations } from "next-intl";

import { LazyMotion, MotionDiv } from "@/components/animate";
import { formatLocalizedCurrency } from "@/lib/localize-currency";

import { InsightsNavScreen } from "./insights-nav-screen";
import { NavPreviewBlueGradientBackground } from "./nav-preview-blue-gradient";
import { navPreviewItem, navPreviewMotionProps } from "./nav-preview-motion";
import { NavFloatingCard, NavPreviewShell } from "./nav-preview-shell";

/** Matches Figma insights preview screen (node 10927:78469). */
export function ResourcesInsightsNavPreview() {
  const locale = useLocale();
  const t = useTranslations("Nav.preview.insights");
  const reduceMotion = useReducedMotion();
  const motionProps = navPreviewMotionProps(reduceMotion);

  const copy = {
    availableBalance: t("availableBalance"),
    netFlow: t("netFlow"),
    netFlowChange: t("netFlowChange"),
    interestEarned: t("interestEarned"),
    interestAmount: formatLocalizedCurrency(28.55, locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    balance: formatLocalizedCurrency(125_085.5, locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    allTime: t("allTime"),
    tooltipDate: t("tooltipDate"),
    tooltipAmount: formatLocalizedCurrency(119_456.87, locale, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }),
    axisStart: t("axisStart"),
    axisEnd: t("axisEnd"),
    tabs: {
      research: t("tabs.research"),
      data: t("tabs.data"),
      analysis: t("tabs.analysis"),
    },
  };

  return (
    <NavPreviewShell>
      <NavPreviewBlueGradientBackground />
      <NavFloatingCard>
        <LazyMotion>
          <MotionDiv className="relative h-full w-full" {...motionProps}>
            <MotionDiv
              className="h-full w-full"
              variants={reduceMotion ? undefined : navPreviewItem}
            >
              <InsightsNavScreen copy={copy} className="size-full" />
            </MotionDiv>
          </MotionDiv>
        </LazyMotion>
      </NavFloatingCard>
    </NavPreviewShell>
  );
}
